import type { MarkerColor } from '@greenroom/shared'
import { clsx } from 'clsx'

export const MARKER_BG: Record<MarkerColor, string> = {
  amber: 'bg-marker-amber',
  teal: 'bg-marker-teal',
  rose: 'bg-marker-rose',
  violet: 'bg-marker-violet',
  sky: 'bg-marker-sky',
}

export const MARKER_TEXT: Record<MarkerColor, string> = { amber: 'text-marker-amber', teal: 'text-marker-teal', rose: 'text-marker-rose', violet: 'text-marker-violet', sky: 'text-marker-sky' }

/** Canvas code needs the colour itself; it mirrors the theme tokens in app.css. */
export const MARKER_HEX: Record<MarkerColor, string> = {
  amber: '#fbbf24',
  teal: '#2dd4bf',
  rose: '#fb7185',
  violet: '#a78bfa',
  sky: '#38bdf8',
}

export function MarkerDot({ color, className }: { color: MarkerColor; className?: string }) {
  return <span className={clsx('inline-block size-2.5 shrink-0 rounded-full', MARKER_BG[color], className)} />
}
